import { useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, Link } from "react-router-dom";
import api from "../services/api";
import { setToastOk } from "../store/features/main/mainSlice";
import { routes } from "../constants/data";

/* eslint-disable jsx-a11y/anchor-is-valid */
export default function Sidebar() {
  const dispatch = useDispatch();
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      await api.post("/admins/logout");
      localStorage.clear();
      sessionStorage.removeItem("token");
      window.location.replace("/login");
    } catch (error) {
      dispatch(setToastOk({
        isOk: false,
        messages: "Đăng xuất thất bại. Vui lòng thử lại.",
      }));
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <div className="w-64 bg-gray-800 text-white flex flex-col h-screen shadow-lg">
      <div className="p-6 text-2xl font-bold border-b border-gray-700">
        <Link to={"/"}>Ji miso</Link>
      </div>

      <nav className="flex-1 flex flex-col py-4 space-y-1">
        {routes.map((route, key) => (
          <NavLink
            key={key}
            to={`/${route.to}`}
            className={({ isActive }) =>
              `px-6 py-3 text-lg text-left transition-colors duration-200 ${
                isActive
                  ? "bg-gray-700 text-white font-semibold"
                  : "hover:bg-gray-700 hover:text-white"
              }`
            }
          >
            {route.title}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-gray-700">
        <button
          onClick={handleLogout}
          disabled={loggingOut}
          className="w-full px-4 py-2 rounded-md text-white font-semibold transition-colors duration-200 hover:underline disabled:opacity-60"
        >
          {loggingOut ? "Đang đăng xuất..." : "Đăng xuất"}
        </button>
      </div>
    </div>
  );
}
